<template>
  <v-row>
    <v-col cols="12">
      <v-text-field
        v-model="result.name"
        label="Név"
        outlined
        dense
      ></v-text-field>
    </v-col>
    <v-col cols="12">
      <v-text-field
        v-model="result.text"
        label="Szöveg"
        outlined
        dense
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'NameAndText',
  props: {
    baseValue: {
      type: Object,
      default: () => ({
        name: '',
        text: '',
      }),
    },
  },
  data() {
    return {
      result: { ...this.baseValue },
    }
  },
  emits: ['formAddEvent'],
  watch: {
    result: {
      handler() {
        this.sendDataToParent()
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    sendDataToParent() {
      const dataToSend = {
        name: this.result.name,
        text: this.result.text,
      }
      this.$emit('formAddEvent', dataToSend)
    },
  },
})
</script>
